import { render, staticRenderFns } from "./OpportunityKanbanView.vue?vue&type=template&id=6f29dd05&scoped=true&"
import script from "./OpportunityKanbanView.vue?vue&type=script&lang=js&"
export * from "./OpportunityKanbanView.vue?vue&type=script&lang=js&"
import style0 from "./OpportunityKanbanView.vue?vue&type=style&index=0&id=6f29dd05&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f29dd05",
  null
  
)

export default component.exports